/** The DSU score in thousandths with its three decimals, as the call publishes it: 502 is "0,502". A dash when a datum it needs is missing. */
export function formatScore(score: number | null, language: string) {
	return score === null
		? '–'
		: new Intl.NumberFormat(language, {
				minimumFractionDigits: 3,
				maximumFractionDigits: 3
			}).format(score / 1000)
}
